import React, { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";

export default function AdminLogin() {
    const { user, login, error } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("admin@ruizconcrete.com");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        if (user && user !== false) navigate("/admin", { replace: true });
    }, [user, navigate]);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        const ok = await login(email, password);
        setBusy(false);
        if (ok) navigate("/admin", { replace: true });
    };

    return (
        <main className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6" data-testid="admin-login-page">
            <div className="w-full max-w-md">
                <Link to="/" className="font-mono-accent text-[10px] text-zinc-500 hover:text-yellow-400">
                    ← BACK TO SITE
                </Link>
                <div className="mt-6 border border-zinc-900 bg-[#0a0a0a] p-8 md:p-10 relative">
                    <div className="absolute top-0 left-0 h-1 w-16 bg-yellow-400" />
                    <div className="w-14 h-14 border border-yellow-400 flex items-center justify-center mb-6">
                        <Lock className="w-6 h-6 text-yellow-400" />
                    </div>
                    <h1 className="font-display text-5xl md:text-6xl">
                        Admin<span className="text-yellow-400">.</span>
                    </h1>
                    <p className="mt-3 text-zinc-500 text-sm">
                        Sign in to manage content, gallery and leads.
                    </p>

                    <form onSubmit={submit} className="mt-8 space-y-5">
                        <div>
                            <label className="font-mono-accent text-[10px] text-zinc-500 block mb-2">
                                EMAIL
                            </label>
                            <input
                                data-testid="admin-email"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full bg-black border border-zinc-800 focus:border-yellow-400 outline-none text-white px-4 py-3 transition-colors"
                            />
                        </div>
                        <div>
                            <label className="font-mono-accent text-[10px] text-zinc-500 block mb-2">
                                PASSWORD
                            </label>
                            <input
                                data-testid="admin-password"
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full bg-black border border-zinc-800 focus:border-yellow-400 outline-none text-white px-4 py-3 transition-colors"
                            />
                        </div>

                        {error ? (
                            <div className="text-red-400 text-sm font-mono-accent tracking-normal" data-testid="admin-error">
                                {error}
                            </div>
                        ) : null}

                        <button
                            data-testid="admin-login-button"
                            disabled={busy}
                            className="w-full bg-yellow-400 text-black font-black uppercase tracking-wider px-6 py-4 text-sm hover:bg-yellow-300 disabled:opacity-60 inline-flex items-center justify-center gap-3"
                        >
                            {busy ? "SIGNING IN…" : "SIGN IN"} <ArrowRight className="w-4 h-4" />
                        </button>
                    </form>
                </div>
            </div>
        </main>
    );
}
